import React, { useContext, useEffect, useRef, useState } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { ObservationFormContext } from "../../hooks/ObservationFormContext";
import { LeaderboardSelectionInputPropsShape } from "../../interfaces/componentTypes";
import { NumericInput } from "./generalUtilities";

export const LeaderBoardSelector: React.FC<LeaderboardSelectionInputPropsShape> = ({
  handleLeaderboardSelection,
  leaderboardStatus,
  approved,
}) => {
  const { t } = useContext(TMDataContext);
  var activeId = "goal-template-leaderboard-selection";

  return (
    <div
      className="goal-boxed-input-area"
      style={{ display: `${approved ? "block" : "none"}` }}
    >
      <div className="goal-form-input-row">
        <label className="goal-input-area-title" htmlFor={activeId}>
          {t("views.goals.headings.leaderboard")}
        </label>
        <input
          name="leaderboardSelection"
          type="checkbox"
          style={{ transform: "scale(1.5)" }}
          checked={leaderboardStatus}
          onChange={handleLeaderboardSelection}
          id={activeId}
        />
        <label
          style={{ marginLeft: "10px", marginRight: "10px" }}
          htmlFor={activeId}
        >
          {t("views.goals.contexts.select_leaderboard")}
        </label>
      </div>
    </div>
  );
};
